import React from "react";
import "../styles/PopUpStyles.css"; // Import styles

interface PopupProps {
  title: string;
  body: string;
  btn1onPressed?: () => void;
  btn2onPressed?: () => void;
}

const QuizPopUp: React.FC<PopupProps> = ({
  title,
  body,
  btn1onPressed,
  btn2onPressed,
}) => {
  return (
    <div className="popupQuiz-overlay">
      <div className="popupQuiz-container">
        <div className="popupQuiz-header">
          <h2>{title}</h2>
        </div>
        <div className="popupQuiz-body">
          <p style={{ fontSize: "20px" }}>{body}</p>
        </div>
        <div className="popupQuiz-footer">
          <button onClick={btn1onPressed} className="popupQuizYes-button">
            Yes
          </button>
          <button onClick={btn2onPressed} className="popupQuizNo-button">
            No
          </button>
        </div>
      </div>
    </div>
  );
};

export default QuizPopUp;
